<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <h1 class="h1 cabinet-title">Списки</h1>
        </header>

        <section class="cabinet-panel flex flex-justify-sb flex-align-center">
            <div class="cabinet-info">
                {{ lists.length }}
                {{
                    getNounByNum(lists.length, ['список', 'списка', 'списков'])
                }}
            </div>
            <button
                type="button"
                class="cabinet-btn cabinet-btn--gray"
                @click="openModal('CreateList')"
            >
                Создать список
            </button>
        </section>

        <div v-if="!loading && error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button type="button" class="cabinet-btn" @click="getLists">
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
        <section v-else class="cabinet-section">
            <list-item
                v-for="list of lists"
                :key="list.ListID"
                :list="list"
                @onClickRemove="data => openModal('RemoveList', data)"
                @onClickAddAllItemsInCart="addAllItemsInCart"
            />
        </section>

        <remove-list-modal
            :is-open="isRemoveListModalOpened"
            :list="RemoveListModalData"
            @onConfirm="removeList"
            @onClose="closeModal('RemoveList')"
        />
        <create-list-modal
            :is-open="isCreateListModalOpened"
            @onConfirm="createNewList"
            @onClose="closeModal('CreateList')"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getNounByNum from '../../../utils/getNounByNum'
import modal from '@/mixins/modal'
import checkDemoUser from '@/mixins/checkDemoUser.js'

import ListItem from '../../../components/Cabinet/Retailer/Lists/ListItem'
import RemoveListModal from '../../../components/Cabinet/Retailer/Lists/RemoveListModal'
import CreateListModal from '../../../components/Cabinet/Retailer/Lists/CreateListModal'

export default {
    name: 'RetailerLists',
    components: {
        ListItem,
        RemoveListModal,
        CreateListModal
    },
    mixins: [modal, checkDemoUser],
    data() {
        return {
            isCreateListModalOpened: false,
            isRemoveListModalOpened: false,
            RemoveListModalData: null,
            error: false,
            loading: true
        }
    },
    computed: {
        ...mapGetters('retailerLists', ['lists'])
    },
    created() {
        this.getLists()
    },
    methods: {
        ...mapActions('retailerLists', {
            createList: 'createList',
            getRetailerLists: 'getLists',
            removeRetailerList: 'removeList'
        }),
        ...mapActions('cart', ['addAllItemsFromList']),
        getNounByNum,
        getLists() {
            this.error = false
            this.loading = true
            this.$Progress.start()

            this.getRetailerLists()
                .finally(() => {
                    this.$Progress.finish()
                    this.loading = false
                })
                .catch(() => {
                    this.error = true
                })
        },
        removeList({ ListID, ListName }) {
            if (this.isDemoUserMode()) return

            this.$Progress.start()
            this.removeRetailerList(ListID)
                .then(() => {
                    this.$notify({
                        title: `Список ${ListName} удален`,
                        type: 'default'
                    })

                    this.closeModal('RemoveList')
                    this.getLists()
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        },
        addAllItemsInCart({ ListID, ListName }) {
            if (this.isDemoUserMode()) return

            this.$Progress.start()

            this.addAllItemsFromList(ListID)
                .then(() => {
                    this.$notify({
                        title: `Изделия из списка ${ListName} добавлены в корзину`,
                        type: 'success'
                    })
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        },
        createNewList(listName) {
            if (this.isDemoUserMode()) return

            this.$Progress.start()

            this.createList(listName)
                .then(() => {
                    this.$notify({
                        title: `Список создан`,
                        type: 'success'
                    })

                    this.closeModal('CreateList')
                    this.getLists()
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        }
    }
}
</script>
